module.exports = __webpack_public_path__ + "static/media/marker.36a29893.svg";